import { tabOutlineWorld } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { MainFeatureTwin, FeatureConfig } from 'src/models'

export interface LinkFeatureTwin extends MainFeatureTwin {
  url: string
}

const featureConfig: FeatureConfig = {
  main: {
    fullWidth: true,
    icon: tabOutlineWorld,
    label: 'Link',
    link: true
  }
}

export default featureConfig
